*,
*::before,
*::after {
  box-sizing: border-box;
}

:host {
  user-select: none;
  display: inline-flex;
  flex-direction: column;
  gap: 8px;
}

.wui-radio-group {
  display: flex;
  flex-direction: column;
  gap: inherit;
}
